import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme: Theme) => ({
  actionsButton: {
    color: theme.palette.text.disabled,
  },
  actionsText: {
    color: theme.palette.text.disabled,
  },
  iconLabel: {
    display: 'flex',
    padding: '2px 0 2px 10px',
  },
  menuPaper: {
    maxHeight: 300,
    width: 180,
  },
  menuItem: {
    minHeight: 'auto',
    padding: theme.spacing(0.5, 1),
  },
  menuItemIcon: {
    minWidth: 32,
  },
  menuItemText: {
    fontSize: '0.875rem',
  },
}));
